import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';

// Create vuex persist object
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    // qr is kept out: it may hold call credentials and visitor coordinates
    modules: ['alerts', 'pass'],
});

import alerts from '@/store/alerts';
import pass from './pass';
import qr from './qr';

// Create the store
export default createStore({
    modules: {
        alerts,
        pass,
        qr,
    },
    plugins: [vuexLocal.plugin],
});
